import { Alert } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useAppNotification } from '@feature/utils';

import { CommitteeForm } from './CommitteeForm';
import { useCommitteeCreate } from './model/CommitteeQuery';
import { CommitteeSchema, committeeSchema, defaultCommitteeValues } from './model/CommitteeSchema';

export function CommitteeCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useCommitteeCreate();
  const navigate = useNavigate();
  const notification = useAppNotification();

  const onSubmit = (values: CommitteeSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newCommittee => {
        notification.success();
        navigate({ to: '/author/committee/$committeeId', params: { committeeId: String(newCommittee.id) } });
      },
    });
  };

  return (
    <>
      <Alert bg="#f9dedf">
        Comisiile de susținere / îndrumare doctoranzi sunt disponibile într-o nouă secțiune (Autor &gt; Îndrumare /
        Susținere doctorat)
      </Alert>
      <CommitteeForm
        title={t('committees.form.title.create')}
        schema={committeeSchema}
        defaultValues={defaultCommitteeValues}
        values={undefined}
        isSubmitting={isPending}
        isError={isError}
        isSuccess={isSuccess}
        onSubmit={onSubmit}
        onCancel={() => navigate({ to: '..' })}
      />
    </>
  );
}
